import { Button, PageHeader } from 'components';
import { Form, Row, Col, Typography, Divider } from 'antd';
import styles from './style.module.scss';
import { CheckOutlined, EyeOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import FileSection from './formSections/file';
import ThirdSection from './formSections/thirdSection';
import FourthSection from './formSections/fourthSection';
import NotificationFormForEdit from 'components/modules/notificationFormForEdit';
import useOperations from '../useOperations';
import FormHelper from 'helpers/FormHelper';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const {
    form,
    shops,
    inactiveShops,
    facilityTypes,
    handleCreateOrUpdate,
    singleItem,
    updateInProcess,
    handleDeleteFile,
    handleApprove,
  } = useOperations(false, !isNew);
  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = isNew
    ? t('NUOVO INTERVENTO FACILITY')
    : t('MODIFICA INTERVENTO FACILITY');

  const isApproveOnly = singleItem.can_approve && !singleItem.can_update;

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Row>
          <Col>
            <Typography.Title level={3}>
              {t(
                'LE RICHIESTE DI INTERVENTO DEVONO ESSERE TRASMESSE CON 48 ORE DI ANTICIPO, SALVO EMERGENZE IMPREVEDIBILI. SI RICORDA CHE QUALSIASI INTERVENTO IN AREA VENDITA PUÒ ESSERE SVOLTO SOLO AL DI FUORI DELL’ORARIO DI APERTURA AL PUBBLICO.',
              )}
            </Typography.Title>
          </Col>
          <Divider />
        </Row>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            facility_type: '',
            description: '',
            date_from: '',
            date_to: '',
            time_from: '',
            time_to: '',
            company_id: '',

            car_type: '',
            center_capacity: '',
            company_contract_person: '',
            company_name: '',
            company_phone: '',
            driver: '',
            driver_contact: '',
            vehicle_number: '',
            worker_quantity: '',
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
          onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
        >
          <InfoSection
            isView={isApproveOnly}
            shops={shops}
            inactiveShops={inactiveShops}
            facilityTypes={facilityTypes}
          />
          <FileSection
            isView={isApproveOnly}
            singleItem={singleItem}
            loading={updateInProcess}
            onDelete={handleDeleteFile}
          />
          {!isNew && (
            <>
              <ThirdSection isView={isApproveOnly} />
              <FourthSection isView={isApproveOnly} />
            </>
          )}
          {!isApproveOnly && (
            <Row gutter={16}>
              <Col>
                <Button
                  onClick={onClickSave}
                  width={'150px'}
                  big
                  icon={<CheckOutlined />}
                >
                  {t('Invia')}
                </Button>
              </Col>
            </Row>
          )}
        </Form>
        {!isNew && (
          <NotificationFormForEdit
            status={singleItem.status}
            loading={updateInProcess}
            handleOnFinish={handleApprove}
            showApprove={!!singleItem.can_approve}
            showReject={!!singleItem.can_reject}
            showToAdim={!!singleItem.can_to_admin}
            showRefuse={!!singleItem.can_refuse}
          />
        )}
      </div>
    </div>
  );
};

export default Edit;
